exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".event-item[data-v-b6d19952]{margin-bottom:2rem}.event-name[data-v-b6d19952]{color:#003f87;font-weight:400;margin-bottom:.5rem}.event-name .date[data-v-b6d19952]{color:#9ab3d5;display:block;font-size:.875rem;font-weight:300;margin-top:.25rem}.event-details[data-v-b6d19952]{font-size:.875rem}.description[data-v-b6d19952]{clear:both;color:#3d444c;font-weight:lighter}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b6d19952","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/events/EventItem.vue
// module id = ./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-b6d19952","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/events/EventItem.vue
// module chunks = 0